import { videosHandler } from './videosInit';
document.addEventListener('DOMContentLoaded', function () {
    videosHandler.init('.js-video', '.js-video-play');
});
